import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";
import { PlayerForm } from "@/components/family/PlayerForm";
import { useSaveAthlete } from "@/lib/family";

export const Route = createFileRoute("/_app/players/new")({
  component: NewPlayerPage,
});

function NewPlayerPage() {
  const navigate = useNavigate();
  const save = useSaveAthlete();
  return (
    <section className="mx-auto max-w-xl">
      <Link to="/home" className="text-sm text-white/60 hover:text-white">
        ← Back
      </Link>
      <h1 className="mt-3 font-display text-4xl font-extrabold uppercase italic">Add player</h1>
      <p className="mt-2 text-sm text-white/70">Add your daughter's details. You can edit them anytime.</p>
      <div className="mt-6">
        <PlayerForm
          submitLabel="Add player"
          onSubmit={async (input) => {
            await save.mutateAsync({ input });
            toast.success(`${input.first_name.trim()} was added.`);
            navigate({ to: "/home" });
          }}
        />
      </div>
    </section>
  );
}
